import * as t from 'io-ts';

import {makeApiType, makeDefaultValueType} from '../api/apiTypes';

/*
 * Supported methods.
 */

export enum LegacyFrameMethodsEnum {
  // Lifecycle.
  LOADED = 'loaded',
  // Standard API.
  COMPOSE = 'compose',
  NAVIGATE = 'navigate',
  OPEN_URL = 'openUrl',
  RESET_OFFLINE_CACHE = 'resetOfflineCache',
}

/*
 * Runtime type.
 */

const RNoArguments = makeDefaultValueType(t.undefined, undefined);

const RLegacyFrameComposeData = t.intersection([
  t.type({
    to: t.readonlyArray(t.string),
  }),
  t.partial({
    subject: t.string,
    source: t.string,
    forcePopout: t.boolean,
  }),
]);

const RLegacyFrameMethodsDirty = t.partial(
  {
    // Lifecycle.
    [LegacyFrameMethodsEnum.LOADED]: RNoArguments,
    // Standard API.
    [LegacyFrameMethodsEnum.COMPOSE]: t.tuple([RLegacyFrameComposeData]),
    [LegacyFrameMethodsEnum.NAVIGATE]: t.tuple([t.string]),
    [LegacyFrameMethodsEnum.OPEN_URL]: t.tuple([t.string]),
    [LegacyFrameMethodsEnum.RESET_OFFLINE_CACHE]: RNoArguments,
  },
  'LegacyFrameMethods',
);

/*
 * Types.
 */

export interface LegacyFrameComposeDataModel extends t.TypeOf<typeof RLegacyFrameComposeData> {}
export interface LegacyFrameMethodsModel extends t.TypeOf<typeof RLegacyFrameMethodsDirty> {}
export const RLegacyFrameMethods = t.clean<LegacyFrameMethodsModel>(RLegacyFrameMethodsDirty as any);

/*
 * IO methods.
 */

function parseLegacyFrameMethods(src: any): LegacyFrameMethodsModel {
  return src;
}

/*
 * API type.
 */

export const ApiLegacyFrameMethods = makeApiType(
  'legacyFrameMethods',
  RLegacyFrameMethods,
  parseLegacyFrameMethods,
);
